import React from 'react';
import Spinner from '../../assets/img/spinner.gif';

const spinner = () => <div className="lds-ring-wrapper"><div className="lds-ring"><img src={ Spinner } alt=""/></div></div>;

export default spinner;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner.js